import { types } from "../types/types";

const initialState = {

  listFullCatalogPhases: [],
  listCatalogPhasesLevel1: [],
  listCatalogPhasesLevel2: [],
  listCatalogPhasesLevel3: [],
  listCatalogPhasesLevel4: [],
  listCatalogPhasesLevel5: [],
  listCatalogPhasesLevel6: [],
  objectCatalogPhaseLevel1Selected: {},
  objectCatalogPhaseLevel2Selected: {},
  objectCatalogPhaseLevel3Selected: {},
  objectCatalogPhaseLevel4Selected: {},
  objectCatalogPhaseLevel5Selected: {},
  objectCatalogPhaseLevel6Selected: {},

  catalogphases_idLevel1: [],
  listCatalogPhasesLevel2: [],
  listCatalogPhasesLevel3: [],
  listCatalogPhasesLevel4: [],
  listCatalogPhasesLevel5: [],
  listCatalogPhasesLevel6: [],
  catalogphase_levelsSelected: {},
  objectCatalogPhaseLevel2Selected: {},
  objectCatalogPhaseLevel3Selected: {},
  objectCatalogPhaseLevel4Selected: {},
  objectCatalogPhaseLevel5Selected: {},
  objectCatalogPhaseLevel6Selected: {},

  catalogPhaseAllLevel6: [],

  catalogPhase: {},
  catalogPhases: [],
  catalogPhasesP: [],
  catalogPhasesS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
  
  listFullCatalogPhasesNoLevel6: []
};
export const catalogPhaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOGPHASE_START_LOADING_LEVEL1:
      return {
        ...state,
        listCatalogPhasesLevel1: action.payload,
      };

    case types.CATALOGPHASE_SELECT_LEVEL1:
      return {
        ...state,
        objectCatalogPhaseLevel1Selected: action.payload,
      };

    case types.CATALOGPHASE_START_LOADING_LEVEL2:
      return {
        ...state,
        listCatalogPhasesLevel2: action.payload,
      };

    case types.CATALOGPHASE_SELECT_LEVEL2:
      return {
        ...state,
        objectCatalogPhaseLevel2Selected: action.payload,
      };

    case types.CATALOGPHASE_START_LOADING_LEVEL3:
      return {
        ...state,
        listCatalogPhasesLevel3: action.payload,
      };

    case types.CATALOGPHASE_SELECT_LEVEL3:
      return {
        ...state,
        objectCatalogPhaseLevel3Selected: action.payload,
      };

    case types.CATALOGPHASE_START_LOADING_LEVEL4:
      return {
        ...state,
        listCatalogPhasesLevel4: action.payload,
      };

    case types.CATALOGPHASE_SELECT_LEVEL4:
      return {
        ...state,
        objectCatalogPhaseLevel4Selected: action.payload,
      };

    case types.CATALOGPHASE_START_LOADING_LEVEL5:
      return {
        ...state,
        listCatalogPhasesLevel5: action.payload,
      };

    case types.CATALOGPHASE_SELECT_LEVEL5:
      return {
        ...state,
        objectCatalogPhaseLevel5Selected: action.payload,
      };

    case types.CATALOGPHASE_START_LOADING_LEVEL6:
      return {
        ...state,
        listCatalogPhasesLevel6: action.payload,
      };

    case types.CATALOGPHASE_SELECT_LEVEL6:
      return {
        ...state,
        objectCatalogPhaseLevel6Selected: action.payload,
      };

    case types.CATALOGPHASE_CLEAN_LEVEL1:
      return {
        ...state,
        objectCatalogPhaseLevel2Selected: {},
        listCatalogPhasesLevel2: [],
        objectCatalogPhaseLevel3Selected: {},
        listCatalogPhasesLevel3: [],
        objectCatalogPhaseLevel4Selected: {},
        listCatalogPhasesLevel4: [],
        objectCatalogPhaseLevel5Selected: {},
        listCatalogPhasesLevel5: [],
        objectCatalogPhaseLevel6Selected: {},
        listCatalogPhasesLevel6: [],
      };

    case types.CATALOGPHASE_CLEAN_LEVEL2:
      return {
        ...state,
        objectCatalogPhaseLevel3Selected: {},
        listCatalogPhasesLevel3: [],
        objectCatalogPhaseLevel4Selected: {},
        listCatalogPhasesLevel4: [],
        objectCatalogPhaseLevel5Selected: {},
        listCatalogPhasesLevel5: [],
        objectCatalogPhaseLevel6Selected: {},
        listCatalogPhasesLevel6: [],
      };

    case types.CATALOGPHASE_CLEAN_LEVEL3:
      return {
        ...state,
        objectCatalogPhaseLevel4Selected: {},
        listCatalogPhasesLevel4: [],
        objectCatalogPhaseLevel5Selected: {},
        listCatalogPhasesLevel5: [],
        objectCatalogPhaseLevel6Selected: {},
        listCatalogPhasesLevel6: [],
      };

    case types.CATALOGPHASE_CLEAN_LEVEL4:
      return {
        ...state,
        objectCatalogPhaseLevel5Selected: {},
        listCatalogPhasesLevel5: [],
        objectCatalogPhaseLevel6Selected: {},
        listCatalogPhasesLevel6: [],
      };

    case types.CATALOGPHASE_CLEAN_LEVEL5:
      return {
        ...state,
        objectCatalogPhaseLevel6Selected: {},
        listCatalogPhasesLevel6: [],
      };

    /* Esto no esta todavia */
    case types.CATALOGPHASE_UPDATE:
      if (state.catalogPhasesS.length > 0) {
        return {
          ...state,
          catalogPhasesS: state.catalogPhasesS.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
          catalogPhasesP: state.catalogPhasesP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      } else {
        return {
          ...state,
          catalogPhasesP: state.catalogPhasesP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      }

    case types.CATALOGPHASE_DELETE:
      if (state.catalogPhasesS.length > 0) {
        return {
          ...state,
          catalogPhasesS: state.catalogPhasesS.filter((usr) => usr.id !== action.payload),
          catalogPhasesP: state.catalogPhasesP.filter((usr) => usr.id !== action.payload),
          catalogPhase: {},
        };
      } else {
        return {
          ...state,
          catalogPhasesP: state.catalogPhasesP.filter((usr) => usr.id !== action.payload),
          catalogPhase: {},
        };
      }

    case types.CATALOGPHASE_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogPhasesP: action.payload.catalogPhasesP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOGPHASE_START_SEARCH:
      return {
        ...state,
        catalogPhasesS: action.payload,
      };

    case types.CATALOGPHASE_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogPhasesP: action.payload.catalogPhasesP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOG_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogPhasesS: [],
      };

      /*Add */
    case types.CATALOGPHASE_SELECT:
      return {
        ...state,
        catalogPhase: action.payload,
      };

    case types.CATALOGPHASE_CLEAN:
      return {
        ...state,
        catalogPhase: {},
      };

    case types.CATALOGPHASE_START_REGISTER:
      return {
        ...state,
        catalogPhase: action.payload,
      };

    case types.CATALOGPHASE_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.CATALOGPHASE_START_LOADING_ALL_LEVEL6:
      return {
        ...state,
        catalogPhaseAllLevel6: action.payload,
      };

    case types.CATALOGPHASE_START_LOADING_ALL:
      return {
        ...state,
        listFullCatalogPhases: action.payload,
      };

      case types.CATALOGPHASE_START_LOADING_NO_LEVEL6:
      return {
        ...state,
        listFullCatalogPhasesNoLevel6: action.payload,
      };

    case types.CATALOGPHASE_START_LOADING_FILTER:

      if (action.payload == null || typeof action.payload !== 'object') {
        return state;
      }

      const { catalogphase_level1_codes } = action.payload;

      const catalogPhaseIdsList = catalogphase_level1_codes && catalogphase_level1_codes.split(",");

      return {
        ...state,

        listPhasesFilter: getFilterCatalog(state.listCatalogPhasesLevel1, catalogPhaseIdsList),

      };

    default:
      return state;
  }
};

const getFilterCatalog = (arrayFull, uniqueArray) => {
  
  let listFilterCatalog = [];

  if (uniqueArray) {

    for (const idUniqueFound of uniqueArray) {
      
      for (const elemSearch of arrayFull) {
        
        const codeFirstLetter = elemSearch.code && elemSearch.code.substring(0, 1);
        if (idUniqueFound === codeFirstLetter) {
          
          elemSearch.isChecked = false;
          listFilterCatalog.push(elemSearch);
        }
      }
    }
  }

  listFilterCatalog.sort((a, b) => a.id - b.id)

  return listFilterCatalog;
}